import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SequenceService {
  baseUrl = 'json/sequence';

  constructor(
    protected http: HttpClient
  ) {}

  getNextSequenceNumber(sequenceName: string, minValue?: number) {
    const headers = {
      maxAge: '-1'
    };
    // add minValue as a parameter
    const params = !!minValue ? {  minValue: minValue } : {};
    return this.http.get<number>(`${this.baseUrl}/${sequenceName}/next`, { headers, params });
  }
}
